import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1C65AC",
      "fill-rule": "evenodd",
      d: "m21.051 7.373-6.927 5.742.592.7L23 6.888 14.717 0l-.594.7 6.93 5.743H.912v.921H21.05z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }